import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ProductsItemFilter } from "../../../../components/user/products/all-item/list-filter";
import { useGetProductByAll2Mutation } from "../../../../store/user/userProductApiSlice";

export interface SelectType { channel: boolean; resoluation: boolean; features: boolean }

export const ProductsAllItem = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // URL 파라미터 추출
    const searchParams = new URLSearchParams(location.search);
    const channel = searchParams.get('ch') || '';
    const resolution = searchParams.get('rs') || '';
    const features = searchParams.get('ft') || '';

    const [data, setData] = useState<any[]>([]);
    const [getProductByAll2Api] = useGetProductByAll2Mutation();
    const [param, setParam] = useState<any>({
        channelType: channel,
        resolutionType: resolution,
        featuresType: features,
        page: 1,
        size: 10
    });

    // API 호출 함수
    const getList = async (currentParam: any) => {
        const result: any = await getProductByAll2Api(currentParam);
        if (result?.data?.Result === 'true') {
            const filteredList = (result.data.List || []).filter(
              (item: any) => item.productType === 'D'
            );
            setData(filteredList);
        } else {
            setData([]);
        }
    };

    // 파라미터 변경 시 API 재호출
    useEffect(() => {
        getList(param);
    }, [param.channelType, param.resolutionType, param.featuresType]);

    // URL 쿼리 스트링 변경 시 param 상태 업데이트
    useEffect(() => {
        setParam((prev: any) => ({
            ...prev,
            channelType: channel,
            resolutionType: resolution,
            featuresType: features
        }));
    }, [channel, resolution, features]);

    /**
     * [핵심 수정 부분]
     * 데이터 정렬 로직: 지정된 ID 제품들을 우선 순위에 따라 상단 배치
     */
    const sortedData = useMemo(() => {
        if (!data || data.length === 0) return [];

        // 상단에 고정하고 싶은 순서 (ID 역순 또는 원하는 순서대로 배열)
        const priorityIds = ['44', '43', '42', '40', '41', '38'];

        // 1. 우선 순위 대상 아이템만 추출
        const itemsToMove = data.filter((item: any) => priorityIds.includes(String(item?.productId)));

        // 2. 그 외 나머지 아이템 추출
        const remainingItems = data.filter((item: any) => !priorityIds.includes(String(item?.productId)));

        // 3. 우선 순위 아이템들을 priorityIds 배열의 인덱스 순서대로 정렬
        itemsToMove.sort((a, b) => {
            return priorityIds.indexOf(String(a.productId)) - priorityIds.indexOf(String(b.productId));
        });

        // 4. 합쳐서 반환 (검색 결과에 1개만 있어도 그 아이템이 맨 위로 올라옴)
        return [...itemsToMove, ...remainingItems];
    }, [data]);

    return (
      <>
          <div className="grayBox">
              <ProductsItemFilter
                channel={channel}
                resolution={resolution}
                features={features}
              />
          </div>
          <div className="contentBox">
              <div className="titleBox">
                  <h2>PRODUCT INFORMATION</h2>
              </div>
              <ul>
                  {sortedData.map((list: any) => (
                    <li key={list?.productId}>
                        <div>
                            <div
                              className="left"
                              onClick={() => navigate(`/products/${list?.productId}?product=${list?.productName.replace(/ /g, "-")}`)}
                            >
                                <div className="imgBox">
                                    <img src={list?.productWhiteImageFile} alt={list?.productName} />
                                </div>
                            </div>
                            <div className="right">
                                <h3
                                  onClick={() => navigate(`/products/${list?.productId}?product=${list?.productName.replace(/ /g, "-")}`)}
                                >
                                    {list?.productName}
                                </h3>
                                <div dangerouslySetInnerHTML={{ __html: list?.icons }}></div>
                            </div>
                        </div>
                    </li>
                  ))}
              </ul>
              {sortedData.length === 0 && <p style={{textAlign:'center', padding:'20px'}}>No products found.</p>}
          </div>
      </>
    );
};
